var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95079 5.29288L1.71079 1.05288C1.61783 0.95915 1.50723 0.884755 1.38537 0.833987C1.26351 0.783218 1.1328 0.75708 1.00079 0.75708C0.868781 0.75708 0.738075 0.783218 0.616216 0.833987C0.494356 0.884755 0.383755 0.95915 0.290792 1.05288C0.104542 1.24024 0 1.49369 0 1.75788C0 2.02206 0.104542 2.27552 0.290792 2.46288L3.83079 6.00288L0.290792 9.54288C0.104542 9.73024 0 9.98369 0 10.2479C0 10.5121 0.104542 10.7655 0.290792 10.9529C0.384233 11.0456 0.495049 11.1189 0.616886 11.1686C0.738724 11.2184 0.869186 11.2436 1.00079 11.2429C1.1324 11.2436 1.26286 11.2184 1.3847 11.1686C1.50654 11.1189 1.61735 11.0456 1.71079 10.9529L5.95079 6.71288C6.04452 6.61992 6.11891 6.50931 6.16968 6.38745C6.22045 6.2656 6.24659 6.13489 6.24659 6.00288C6.24659 5.87087 6.22045 5.74016 6.16968 5.6183C6.11891 5.49644 6.04452 5.38584 5.95079 5.29288Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.a0ac962ff2df0adabdad9ed0fd4c710c.svg";
export { ForwardRef as ReactComponent };